import { setAuthenticator } from '@ms/yammer-web-authenticators';
import type MsalRedirectAuthenticator from '@ms/yammer-web-authenticators/dist/redirect/MsalRedirectAuthenticator';
import { getNetworkContext } from '@ms/yammer-web-support/dist/location';

import config from '../config';

import { reportAuthError } from './reportAuthError';

const getAuthenticator = async (): Promise<MsalRedirectAuthenticator> => {
  const networkContext = getNetworkContext(window.location.pathname);
  let tenant = config.msal.tenant;
  if (networkContext?.networkType === 'Canonical') {
    tenant = networkContext.permalink;
  }

  // oxlint-disable-next-line typescript/no-explicit-any
  (config as any).adal = config.msal;
  const { default: MsalRedirectAuthenticator } = await import(
    /* webpackChunkName: "4-auth-msal" */ '@ms/yammer-web-authenticators/dist/redirect/MsalRedirectAuthenticator'
  );

  return new MsalRedirectAuthenticator({
    ...config.msal,
    tenant,
    onError: reportAuthError,
    isPairwiseBrokerEnabled: true,
  });
};

export type SetupAuthenticator = () => ReturnType<typeof getAuthenticator>;
export const setupAuthenticator: SetupAuthenticator = async () => {
  const authenticator = await getAuthenticator();

  setAuthenticator(authenticator);

  return authenticator;
};
